"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var REPLACERS = [[/yyyy|YYYY/, function (date) {
  return date.getFullYear();
}], [/yy|YY/, function (date) {
  return date.getFullYear().toString().slice(2);
}], ['MM', function (date) {
  return DateFormatter._addLeadingZeros(date.getMonth() + 1);
}], ['M', function (date) {
  return date.getMonth() + 1;
}], ['DD', function (date) {
  return DateFormatter._addLeadingZeros(date.getDate());
}], ['D', function (date) {
  return date.getDate();
}], ['HH', function (date) {
  return DateFormatter._addLeadingZeros(date.getHours());
}], ['H', function (date) {
  return date.getHours();
}], ['mm', function (date) {
  return DateFormatter._addLeadingZeros(date.getMinutes());
}], ['m', function (date) {
  return date.getMinutes();
}], ['ss', function (date) {
  return DateFormatter._addLeadingZeros(date.getSeconds());
}], ['s', function (date) {
  return date.getSeconds();
}], ['SSS', function (date) {
  return date.getMilliseconds();
}], ['SS', function (date) {
  return Math.floor(date.getMilliseconds() / 10);
}], ['S', function (date) {
  return Math.floor(date.getMilliseconds() / 100);
}]];
/**
 * Handles formatting of dates.
 */

var DateFormatter = /*#__PURE__*/function () {
  function DateFormatter() {
    _classCallCheck(this, DateFormatter);
  }

  _createClass(DateFormatter, null, [{
    key: "isoStringToDate",

    /**
     * Formats a date.
     *
     * @param {string} dateString Date string.
     * @returns {Date} Formatted date.
     */
    value: function isoStringToDate(dateString) {
      return new Date(dateString.replace('Z', ''));
    }
    /**
     * Formats a date object to a date string.
     *
     * @param {Date|string|number} date Date object, or string/number to pass into the date constructor.
     * @param {string} [format] Format to use. Default is "YYYY-MM-DD".
     * @returns {string} Formatted date.
     */

  }, {
    key: "dateToString",
    value: function dateToString(date) {
      var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'YYYY-MM-DD';

      if (!(date instanceof Date)) {
        date = new Date(date);
      }

      if (isNaN(date.getTime())) {
        return date.toString();
      }

      return REPLACERS.reduce(function (str, _ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            pattern = _ref2[0],
            fnc = _ref2[1];

        var arr = str.split(pattern);

        if (arr.length === 1) {
          return arr[0];
        }

        return arr.join(fnc(date));
      }, format);
    }
    /**
     * Adds leading zeross to a number.
     *
     * @param {number|string} value Number to add leading zeros to.
     * @returns {string} Number with leading zeros converted to a string.
     */

  }, {
    key: "_addLeadingZeros",
    value: function _addLeadingZeros(value) {
      value = String(value);

      while (value.length < 2) {
        value = '0' + value;
      }

      return value;
    }
  }]);

  return DateFormatter;
}();

exports.default = DateFormatter;